import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { inlineCardNodeView } from './inlineCard';
export var lazyInlineCardView = function lazyInlineCardView(props) {
  var isPageSSRed = props.isPageSSRed || false;
  if (editorExperiment('platform_editor_exp_lazy_node_views', false) || isPageSSRed && fg('platform_ssr_smartlinks_editor')) {
    return inlineCardNodeView(props);
  }
  return withLazyLoading({
    nodeName: 'inlineCard',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-inline-card-item-nodeview" */
      './inlineCard').then(function (_ref) {
        var inlineCardNodeView = _ref.inlineCardNodeView;
        return inlineCardNodeView(props);
      });
      return result;
    }
  });
};